import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      color: '#373737',
      fontFamily: theme.value.typography.fontFamily,
    },
    '&__container': {
      gap: theme.value.spacing,
      display: 'flex',
      flexDirection: 'column',
      width: '358px',
    },
    '&__label': {
      display: 'block',
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.semibold,
      lineHeight: '1.25rem',
    },
    '&__wrapper': {
      position: 'relative',
    },
    '&__dropdown': {
      position: 'relative',
    },
    '&__select': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      background: '#fff',
      border: `1px solid ${theme.value.colors.gray.light2}`,
      borderRadius: theme.value.input.borderRadius,
      padding: '0.25rem 0.5rem',
      gap: '0.5rem',
      height: '32px',
      fontSize: '0.8125rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.regular,
      lineHeight: '1.375rem',
      MozAppearance: 'none',
      WebkitAppearance: 'none',
      appearance: 'none',
      backgroundImage:
          "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='black'><path fill-rule='evenodd' d='M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z' clip-rule='evenodd' stroke='black' stroke-width='1'/></svg>\")",
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 0.7rem top 50%',
      backgroundSize: '0.65rem auto',
      '&:hover': {
        borderColor: theme.value.colors.gray.medium2,
      },
      '&:focus': {
        borderColor: theme.value.colors.primary.light1,
      },
      '&:focus-visible': {
        outline: 'none',
      },
      '&:disabled': {
        backgroundColor: theme.value.colors.gray.light3,
        borderColor: theme.value.colors.gray.light3,
        cursor: 'not-allowed',
      },
      '&--placeholder': {
        color: theme.value.colors.gray.medium2,
      },
      '&--open': {
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
      },
      '&--left-icon': {
        paddingLeft: '2rem',
      },
    },
    '&__selected-value': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
    },
    '&__menu-wrapper': {
      position: 'absolute',
      top: '100%',
      left: 0,
      width: '100%',
      border: `1px solid ${theme.value.colors.gray.light2}`,
      borderTopRightRadius: '4px',
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      backgroundColor: '#fff',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
      overflow: 'hidden',
      zIndex: 1000,
    },
    '&__menu': {
      margin: 0,
      padding: '0.125rem 0.75rem 0.125rem 0.375rem',
      listStyle: 'none',
      maxHeight: '14.25rem',
      overflowY: 'auto',
      scrollbarWidth: 'none',
    },
    '&__menu-scrollbar': {
      position: 'absolute',
      top: '0.1875rem',
      bottom: '0.5rem',
      right: '0.25rem',
      width: '4px',
      borderRadius: '999px',
      backgroundColor: theme.value.colors.gray.light4,
      opacity: 0,
      transition: 'opacity 120ms ease',
      pointerEvents: 'auto',
      '&--visible': {
        opacity: 1,
      },
    },
    '&__menu-scrollbar-thumb': {
      width: '100%',
      borderRadius: '999px',
      backgroundColor: theme.value.typography.color,
      transition: 'transform 120ms ease',
      cursor: 'grab',
    },
    '&__icon': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: '1rem',
      zIndex: 1,
      pointerEvents: 'none',
      '&--left': {
        left: '0.5rem',
      },
    },
    '&__helper-text': {
      fontSize: '0.75rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.regular,
      lineHeight: '1.125rem',
      color: theme.value.colors.gray.medium1,
    },
    '&--error &__select, &--error &__select:focus': {
      borderColor: theme.value.colors.error,
    },
    '&--error &__helper-text': {
      color: theme.value.colors.error,
    },
    '&--full-width': {
      width: '100%',
    },
  }));

  return baseClass;
};
